import {normalizeLanguageCode} from 'enums';
import {isEditor, isStaffHasPermission} from 'utils/role';
import {accountRoleOptions} from 'utils/accountRoles';

export const getPostAccountRole = (roles) => accountRoleOptions.find(({value}) =>
  Array.isArray(roles) && roles.some((role) => (typeof role === 'string' ? role : role?.title)?.toLowerCase() === value))?.value;
export const canAccessPostWorkspace = (roles) => Boolean(getPostAccountRole(roles));
export const isPostWorkspacePage = (page) => ['PROJECT', 'INFORMATION'].includes(page?.pageType);
export const hasPostPagePermission = (roles, page, actions) => Boolean(page && (
  isPostWorkspacePage(page) ? canAccessPostWorkspace(roles) :
    (['PRODUCT', 'COMPANY'].includes(page.pageType) && canReviewPosts(roles)) ||
    isStaffHasPermission(roles, [page.pageType.toLowerCase()], actions)
));
export const canReviewPosts = (roles) => ['admin', 'reviewer', 'manager'].includes(getPostAccountRole(roles));

const userId = (user) => typeof user === 'string' ? user : user?._id || user?.id;
export const isPostAuthor = (user, post) => Boolean(
  userId(user) && userId(post?.createdBy) && String(userId(user)) === String(userId(post.createdBy))
);
export const canMutatePost = (user, post, page, hasPagePermission) =>
  canEditPost(user.roles, post, hasPagePermission) && (!isPostWorkspacePage(page) ||
    (canAccessPostWorkspace(user.roles) && (canReviewPosts(user.roles) || isPostAuthor(user, post))));

export const canEditPostLanguage = (roles, language) =>
  canReviewPosts(roles) ||
  (getPostAccountRole(roles) !== 'editor' && !isEditor(roles)) ||
  normalizeLanguageCode(language) === 'EN';

export const canEditPost = (roles, post, hasPagePermission) =>
  Boolean(
    hasPagePermission &&
      post?._id &&
      !post.isLocked &&
      !post.translationDraft &&
      canEditPostLanguage(roles, post.language)
  );

export const hasPostPublicationRole = (roles) => canReviewPosts(roles);
export const canManagePostPublication = (roles, post, hasPagePermission) =>
  Boolean(hasPagePermission && post?._id && !post.isLocked && !post.translationDraft && hasPostPublicationRole(roles));

export const canUsePostPublicationControls = (user, post, page, hasPagePermission) =>
  canManagePostPublication(user.roles, post, hasPagePermission) ||
  (canMutatePost(user, post, page, hasPagePermission) && (!isPostWorkspacePage(page) ||
    (isEditor(user.roles) && normalizeLanguageCode(post.language) === 'EN' && isPostAuthor(user, post))));
